import { render, staticRenderFns } from "./InboxDeclineForm.vue?vue&type=template&id=5e2d36d1&scoped=true&"
import script from "./InboxDeclineForm.vue?vue&type=script&lang=js&"
export * from "./InboxDeclineForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2d36d1",
  null
  
)

export default component.exports